<nav class="navbar navbar-expand-md position-relative justify-content-start bg-white px-1 py-md-0 px-sm-3 shadow-sm"
    *ngIf="authService?.currentUser?.fullName && configService?.pageTitle">
    <button class="navbar-toggler p-2 border-0 badge rounded-circle" data-bs-toggle="collapse" data-bs-target="#side-nav-opt"
        type="button" (click)="toggleSideNav(optSideNavSpy)">
        <span class="navbar-toggler-icon"></span>
    </button>

    <a class="navbar-brand me-0 me-md-3 d-flex align-items-center px-md-1" data-bs-toggle="tooltip" data-bs-placement="bottom"
        data-bs-html="true" routerLink="{{authService?.currentUser?.isSuperAdminUser ? '/admin' : '/domain'}}"
        title="<span> UI Version: {{uiVersion}}</span>">
        <i class="increff-client-icons increff-logo me-2 text-increff-orange"></i>
        <i class="increff-client-icons increff-text me-2 small text-dark"></i>
        <span class="text-dark">ACCOUNT</span>
    </a>
    <div class="position-absolute badge bg-white shadow-sm text-secondary px-3 application-pill" *ngIf="authService?.currentUser?.appName">
      <span>Application: {{authService?.currentUser?.appName}}</span>
    </div>

    <div class="col-auto collapse navbar-collapse pt-2 pt-md-0 px-md-0" id="side-nav-opt" #optSideNavSpy>
        <a class="navbar-brand d-md-none" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-html="true" routerLink="/"
            attr.data-bs-original-title="<span>Application Version: 1.0</span> <br><span> UI Version: {{uiVersion}}</span>"
            (click)="toggleSideNav(optSideNavSpy)">
            <i class="increff-client-icons increff-logo me-2 ms-2 text-increff-orange"></i>
            <i class="increff-client-icons increff-text me-2 small"></i>
            <span>ACCOUNT</span>
        </a>

        <ul class="navbar-nav mt-2 mt-md-0">
            <li class="nav-item dropdown nav-dropdown rounded-2 py-1 px-3 me-lg-3" routerLinkActive="active"
                *ngFor="let route of routeTree">
                <ng-container *ngIf="route?.name === 'Admin' ? authService?.currentUser?.isSuperAdminUser : true">

                  <ng-container *ngIf="!route?.children?.length">
                    <a class="nav-link" [routerLink]="route?.baseUrl" (click)="toggleSideNav(optSideNavSpy)">
                        <i class="h5 mb-0 me-2 mdi mdi-{{route?.iconClass}} "></i>
                        <span>{{route?.name}}</span>
                    </a>
                </ng-container>

                <ng-container *ngIf="route?.children?.length">
                    <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown" role="button"
                        (mouseenter)="toggleDropend($event); ">
                        <i class="h5 mb-0 me-2 mdi mdi-{{route?.iconClass}} "></i>
                        <span>{{route?.name}}</span>
                        <i class="h5 mb-0 ms-2 mdi mdi-chevron-down "></i>
                    </a>
                    <div class="dropdown-menu position-absolute border-0 rounded shadow ms-2 ms-md-0 mt-md-1 p-0 m-0 ">
                        <ng-container *ngFor="let childrenRoute of route?.children; last as isLast">
                            <a class="dropdown-item p-2" [routerLink]="childrenRoute?.baseUrl"
                                routerLinkActive="active" (click)="toggleDropend($event); toggleSideNav(optSideNavSpy)">{{childrenRoute?.name}}</a>
                            <div class="dropdown-divider" *ngIf="!isLast"></div>
                        </ng-container>
                    </div>
                </ng-container>

              </ng-container>
            </li>
        </ul>
    </div>
    <!-- {{routeTree | json}} -->

    <span class="overlay" *ngIf="optSideNavSpy?.dataShow" (click)="toggleSideNav(optSideNavSpy)"></span>

    <ul class="nav navbar-nav ms-auto" *ngIf="authService?.currentUser?.fullName">
        <li class="nav-item dropdown">

            <button class="btn d-inline-flex align-items-center text-primary shadow-none dropdown-toggle border rounded-pill p-0 bg-white font-size-90" id="navOpts" data-bs-toggle="dropdown">
                <div class="bg-secondary rounded-circle d-flex justify-content-center align-items-center me-2" style="width:1.5rem; height:1.5rem;">
                  <span class="text-light">{{authService?.currentUser?.fullName?.trim() | slice: 0:1 | uppercase}}</span>
                </div>
                <span class="me-1 font-medium">{{ authService?.currentUser?.fullName}}
                  <span *ngIf="authService?.currentUser?.domainName"> | {{authService?.currentUser?.domainName}}</span>
                </span>
                <i class="mdi mdi-chevron-down me-1"></i>
            </button>

            <div class="dropdown-menu dropdown-menu-end profile-card position-absolute border-0 rounded shadow-sm py-0" id="all-opts">
                <div class="card border-0">
                  <div class="card-header border-0 h-100 d-flex flex-column align-items-center p-3">
                    <img class="rounded-circle profile-image border border-light" alt="{{authService?.currentUser?.fullName?.trim()}}userImage" src="{{authService?.currentUser?.profileImage}}" *ngIf="authService?.currentUser?.profileImage" >
                    <div class="profile-icon bg-secondary rounded-circle d-flex align-items-center justify-content-center" *ngIf="!authService?.currentUser?.profileImage">
                      <span class="profile-icon-text mb-2 text-light">{{authService?.currentUser?.fullName?.trim() | slice: 0:1 | uppercase}}</span>
                    </div>
                    <div class="d-flex flex-column align-items-center mt-2 text-dark">
                      <h5 class="font-weight-normal mb-1">{{authService?.currentUser?.fullName | ellipsis: 20}}</h5>
                      <span class="small text-center">{{authService?.currentUser?.email}}</span>
                    </div>
                  </div>
                  <hr class="border border-secondary rounded-circle m-0">
                  <div class="card-body p-2">
                    <div class="row m-0">
                        <!-- [routerLink]="[activatedRoute?._routerState?.snapshot?.url, {manageProfile: true}]" -->
                        <!-- <button type="button" appButton class="dropdown-item rounded w-50 p-2 d-flex flex-column pointer align-items-center" data-bs-toggle="modal" data-bs-target="#manage-user-profile-modal">
                          <i class="mdi mdi-account mdi-24px"></i>
                          <span class="font-small">Manage Profile</span>
                        </button> -->
                      <ng-container *ngFor="let navItem of userRoutes">
                        <button type="button" appButton class="dropdown-item rounded w-50 p-2 d-flex flex-column pointer align-items-center" attr.data-bs-toggle="{{navItem?.dataToggle}}" attr.data-bs-target="{{navItem?.dataTarget}}" *ngIf="navItem?.dataToggle" (click)="navItem?.click();">
                            <i class="mdi mdi-{{navItem?.iconClass}} mdi-24px"></i>
                            <span class="font-small">{{navItem?.name}}</span>
                        </button>
                        <div class="dropdown-item rounded w-50 p-2 d-flex flex-column pointer align-items-center" [routerLink]="[navItem?.path]" *ngIf="navItem?.path">
                          <i class="mdi mdi-{{navItem?.iconClass}} mdi-24px"></i>
                          <span class="font-small">{{navItem?.name}}</span>
                        </div>
                        <a [href]="[navItem?.href]" target="_blank" class="dropdown-item rounded w-50 p-2 d-flex flex-column pointer align-items-center" *ngIf="navItem?.showIf">
                          <i class="mdi mdi-{{navItem?.iconClass}} mdi-24px"></i>
                          <span class="font-small">{{navItem?.name}}</span>
                        </a>
                      </ng-container>
                      <div class="dropdown-item logout rounded w-50 p-2 d-flex flex-column pointer align-items-center text-danger" (click)="logout()">
                        <i class="mdi mdi-power mdi-24px"></i>
                        <span class="font-small">Logout</span>
                      </div>
                    </div>
                  </div>
              </div>
              </div>
        </li>
    </ul>
</nav>
